'use client';
import MainMenu from '@/components/MainMenu';
import Footer from '@/components/Footer';
import usePhoneNumber from '@/hooks/usePhoneNumber';
import { useCallback, useEffect, useState } from 'react';
import { sendRequestNoToken } from '@/utils/apiService';
import { prependCoreUrl } from '@/utils/globals';
import { ChevronDown, X } from 'lucide-react';

interface FAQ {
    text: string;
    question: string;
}

const MySchoolPage = () => {
    const { phoneNumber, isCookieLoading } = usePhoneNumber();
    const [isLoading, setIsLoading] = useState(true);
    const [faqs, setFaqs] = useState<FAQ[]>([]);
    const [expandedIndex, setExpandedIndex] = useState<number | null>(null); // Track which FAQ is expanded

    const fetchData = useCallback(() => {
        setIsLoading(true);
        sendRequestNoToken("GET", `/api/faq/`, null)
            .then((data) => {
                setFaqs(data);
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, []);

    // Fetch the data on initial load
    useEffect(() => {
        fetchData();
    }, [fetchData]);

    const toggleFAQ = (index: number) => {
        setExpandedIndex(prevIndex => prevIndex === index ? null : index); // Toggle expanded question
    };

    if (isLoading) {
        return (
            <div className="flex items-center justify-center min-h-screen bg-gray-100 dark:bg-dark-800">
                <div className="text-center">
                    <div className="spinner-border animate-spin inline-block w-16 h-16 border-8 border-solid border-purple-500 border-t-transparent rounded-full"></div>
                    <p className="mt-4 text-xl dark:text-dark-100 text-gray-700">Уншиж байна...</p>
                </div>
            </div>
        );
    }

    return (
        <main className="flex min-h-screen flex-col items-center justify-between overflow-hidden">
            <MainMenu isLoading={isCookieLoading} phoneNumber={phoneNumber} />
            <section className="text-start w-screen justify-start bg-gradient-start min-h-screen dark:bg-dark-700">
                <div className='container mt-28 mb-10 text-center'>
                    <div>
                        <div className='text-4xl md:text-6xl font-semibold'>
                            Түгээмэл <span className='text-purple-500'>Асуулт, Хариулт</span>
                        </div>
                        <div className='text-lg mt-10 max-w-[600px] mx-auto'>
                            {/* Suspendisse id magna at dolor dapibus congue et in urna. Nulla egestas sodales lacus Nulla egestas sodales lacus Nulla egestas sodales lacus */}
                        </div>
                    </div>
                </div>
                <div className="mb-28">
                    <div className="space-y-6">
                        <div className='container' style={{ scrollMarginTop: '6rem' }} id='career'>
                            <div className='flex flex-col space-y-6'>
                                {faqs.map((item, index) => (
                                    <div key={index} className='bg-white p-5 rounded overflow-hidden dark:bg-dark-500'>
                                        <div
                                            onClick={() => toggleFAQ(index)} // Toggle on click
                                            className="cursor-pointer text-xl font-medium text-purple-500 dark:text-white transition select-none flex flex-row justify-between items-center"
                                        >
                                            <div>{item.question}</div>
                                            <div className='transition-all duration-500'>{expandedIndex === index ? <X/>:<ChevronDown/>}</div>
                                            
                                        </div>
                                            <div className={`${expandedIndex === index ? 'max-h-[2000px]' : 'max-h-0'} text-gray-800 dark:text-white transition-all duration-500`} dangerouslySetInnerHTML={{ __html: `${prependCoreUrl(item.text)}` }} />
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer showNavigation={false} />
        </main>
    );
}

export default MySchoolPage;
